import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

window.setConfigs = (cof) => {
    const data = JSON.parse(cof);
    const event = new CustomEvent('configChanged', {
        detail: data
    });
    document.dispatchEvent(event);
}

window.setSensorValue = (value) =>{
    const data = JSON.parse(value)
    const event = new CustomEvent('sensorChanged', {
        detail: data
    });
    document.dispatchEvent(event);
}

const app = createApp(App)
app.use(ElementPlus)
app.use(store)
app.use(router)
app.mount('#app')
